import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const authAPI = {
  /**
   * Login with username and password.
   * The server sets an httpOnly cookie — no token is returned in the body.
   */
  async login(username, password) {
    try {
      const response = await axios.post(
        `${API_URL}/auth/login`,
        { username, password },
        { withCredentials: true },
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Unable to connect to server. Please ensure the backend is running.');
      } else {
        throw new Error(error.message || 'An unexpected error occurred');
      }
    }
  },

  /**
   * Validate current session and get user info.
   * Cookie is sent automatically.
   */
  async getMe() {
    const response = await axios.get(`${API_URL}/auth/me`, {
      withCredentials: true,
    });
    return response.data;
  },

  /**
   * Authenticate with a Google ID token.
   * The server verifies the token, finds/creates the user, and sets an httpOnly cookie.
   */
  async googleLogin(credential) {
    try {
      const response = await axios.post(
        `${API_URL}/auth/google`,
        { credential },
        { withCredentials: true },
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error;
      } else if (error.request) {
        throw new Error('Unable to connect to server. Please ensure the backend is running.');
      } else {
        throw new Error(error.message || 'An unexpected error occurred');
      }
    }
  },

  /**
   * Logout — server blacklists the token and clears the cookie.
   */
  async logout() {
    try {
      await axios.post(`${API_URL}/auth/logout`, {}, {
        withCredentials: true,
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  },
};
